import React from 'react';
import { useCountdown } from '../../hooks/useCountdown';
import { CDV_DEADLINE_ISO } from '../../data/academiaCdv';
const pad = (n: number) => String(n).padStart(2, '0');
export function UrgencyCountdownBar() {
  const {
    days,
    hours,
    minutes,
    seconds,
    expired
  } = useCountdown(CDV_DEADLINE_ISO);
  return <div role="region" aria-label="Cierre de inscripciones" className="sticky top-0 z-50 w-full bg-[#C8102E] text-white shadow-lg" data-id="element-125" data-mp="1tzal765mkla3">
      <div className="max-w-6xl mx-auto px-3 py-2 flex flex-row items-center justify-center gap-x-3 sm:gap-x-4 text-center" data-id="element-126" data-mp="1f9mhxzdvvcjq">
        <p className="text-[0.7rem] sm:text-sm font-bold uppercase tracking-wide whitespace-nowrap" data-id="element-127" data-mp="16baug68bcuvi">
          {expired ? 'Inscripciones cerradas' : <>
              <span className="sm:hidden" data-id="element-128" data-mp="wc1tuuiy0i06">Cierra en:</span>
              <span className="hidden sm:inline" data-id="element-129" data-mp="weobjmzjsdw4">Inscripciones cierran en:</span>
            </>}
        </p>
        {!expired && <p className="font-mono text-sm sm:text-lg font-bold tabular-nums whitespace-nowrap" aria-live="off" data-id="element-130" data-mp="3k9y7h30ohce">
            {days}d : {pad(hours)}h : {pad(minutes)}m : {pad(seconds)}s
          </p>}
        <p className="hidden lg:block text-sm text-white/85" data-id="element-131" data-mp="cky5lsxwnjgb">
          Lunes 12 de Octubre, 11:59 PM (CDMX) ·{' '}
          <span className="font-bold text-white" data-id="element-132" data-mp="7kab2xagwkhc">
            Descuento al hacer pago anual
          </span>
        </p>
      </div>
    </div>;
}